// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vldFk","rightFade":"styles_rightFade__0euf3","leftFade":"styles_leftFade__HF1R2"};